
import {createContext,useContext} from "react"
import { useLoginOnboaring } from "../components/customwidgets/leads-onboarding-sections/hooks/useLoginOnboaring"


export const LeadContext = createContext({
    edit:(leadUuid:string)=>{}
})

export const LeadProvider = ({children}) => {
    const {redirectToOnboarding} = useLoginOnboaring();
    const edit = (leadUuid:string) => {
        redirectToOnboarding(leadUuid)
    }
    return (
        <LeadContext.Provider value={{edit}}>
            {children}
        </LeadContext.Provider>
    )
}
export const useLeadContext = () => useContext(LeadContext)